/**
 * sf-tabs — the tab bar inside `sf-about-tabs`.
 *
 * Progressive enhancement: the section hides all but the first panel with the `hidden`
 * attribute, and the stylesheet reveals every panel again under the theme's `no-js` class,
 * so without JavaScript the content simply stacks instead of disappearing.
 *
 * The buttons follow the ARIA tabs pattern: one tab stop for the whole tab list, arrow keys
 * move between tabs, Home/End jump to the ends.
 */
(function () {
  class SfTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.sf-tabs__tab')];
      this.panels = [...this.querySelectorAll('.sf-tabs__panel')];
      if (this.tabs.length === 0) return;

      this.classList.add('is-enhanced');
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    activate(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.activate(next);
      this.tabs[next].focus();
    }
  }

  if (!customElements.get('sf-tabs')) customElements.define('sf-tabs', SfTabs);
})();
